import * as React from 'react';

import { Button, Modal, Typography } from 'antd';

type PermanentAccessAlertModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const PermanentAccessAlertModal = ({ isOpen, handleClose }: PermanentAccessAlertModalProps) => {
  return (
    <Modal
      open={isOpen}
      onCancel={() => handleClose()}
      width={400}
      title='Acesso permanente'
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button onClick={() => handleClose()} type='primary'>
            Entendi
          </Button>
        </div>
      }
    >
      <Typography.Paragraph className='mb-2.5'>
        <Typography.Text className='text-base'>
          Ativar o acesso permanente garante que o cliente continue com acesso
          <Typography.Text className='font-bold'> mesmo após o fim do contrato.</Typography.Text>
        </Typography.Text>
      </Typography.Paragraph>
    </Modal>
  );
};

export default PermanentAccessAlertModal;
